import { useHistory } from 'react-router-dom';
import { encodeFilterState } from 'components/Filters/ReportFilters/ReportFiltersUtils';

export function useUrlParamUpdater() {
  const { replace } = useHistory();
  return function setUrlParams(filterState) {
    replace({ search: encodeFilterState(filterState) });
  };
}
